export const ReportFilterOptions = {
  MILEAGE_FROM: '104',
  MILEAGE_UP_TO: '105',
};

export const DEFAULT_ANALYTICS_LOCATION = 'other';
export const SUBCRIPTION_PLAN_PERIOD = {
  ONE: 'one',
  THREE: 'three',
  SIX: 'six',
  TWELVE: 'twelve',
};

export const BUSINESS_999_URL = 'https://999.md/cabinet/business';

export const BUSINESS_999_URL_PATHS = {
  CONNECTED_ACCOUNTS: `${BUSINESS_999_URL}/connected_accounts`,
  TARIFFS: `${BUSINESS_999_URL}/tariffs`,
  API: `${BUSINESS_999_URL}/api`,
  DISCOUNTS: `${BUSINESS_999_URL}/discounts_and_bonuses`,
};

// Simpalsbar constants
export const PROJECT_ID =
  process.env.REACT_APP_ENV === 'staging'
    ? '4183c043-7747-4239-86e3-b9eefc6ffc6a'
    : '999a46c6-e6a6-11e1-a45f-283761887099';
export const IS_STAGING = process.env.REACT_APP_ENV === 'staging';

export const CookieName = {
  SessionKey: 'simpalsid.sessionKey',
  SimpalsIdAuth2: 'simpalsid.auth2',
  SimpalsIdAuth: 'simpalsid.auth',
  SimpalsIdLang: 'simpalsid.lang',
};
